import React, { Component } from "react";
import { HelpBlock, FormGroup, FormControl, Panel, PanelGroup, ControlLabel } from "react-bootstrap";
import RenderLander                from "../../components/utils/RenderLander";
import { Colors }                  from "../../utils/Colors"
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import html2canvas                 from 'html2canvas'
import { getImgOrDocTag }          from "../../utils/ImageUpload";
import { WhiteLabel }              from "../../utils/WhiteLabelProps";
import LoaderButton                from "../../components/LoaderButton";
import ModalAlert                  from "../../components/modal/ModalAlert";
import program_category_black_fade from '../../images/utils/program_category_black_fade.png';
import { invokeAddClientProgress } from "../../utils/AwsInvoke";
import { s3PublicUpload }          from "../../libs/awsLib";
import { faDumbbell, faStopwatch }                from '@fortawesome/free-solid-svg-icons'
import "../../css/photo/SocialPhoto.css";

const Compress = require('compress.js');
// Initialization
const compress = new Compress()
WhiteLabel();

export default class Tracker extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: false,
          title: "Workout on " + this.todaysDate(),
          showModalAlert:      false, // true | false
          form_submitted: false,
        };
    }

    todaysDate = () => {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();

        if(dd<10) dd = '0'+dd
        //if(mm<10) mm = '0'+mm

        today = mm + '/' + dd;
        return today;
    }

    validateForm() {
        //return (
          //this.state.email.length > 0 &&
          //this.state.password.length > 0
        //);
    }

    handleTitleChange = event => {
        this.setState({
            title: event.target.value
        });
    }

    handleNotesChange = event => {
        this.setState({
            notes: event.target.value
        });
    }

    handleSubmit = async event => {
          event.preventDefault();

          this.setState({ isLoading: true, showLoadingBar: "inline" });
          var title                       = this.state.title;

          try {

              let photo_id = this.file ? await s3PublicUpload("progress-photos", this.file) : null;

              // If there's an eisting image and a new one hasn't been uploaded, use existing image
              if(photo_id === null || photo_id === undefined)
                  photo_id = this.state.photo_id;

              //const results = await invokeAddClientProgress(title, photo_id);

             /* if(results.status === true) {
                  this.setState({
                      isLoading: false,
                      showLoadingBar: "none",
                      form_submitted: true
                  });
              } else
                 this.setState({ isLoading: false, showLoadingBar: "none", form_submitted: true });*/
          } catch (e) {
              alert("Tracker Error: " + e["message"]);
          }

          this.setState({ isLoading: false });
    }

    handleFileChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.file_orig = event.target.files[0];
            var tmp_file_name = this.file_orig.name; // || .size || ".type"
            var file_type = tmp_file_name.substring(tmp_file_name.lastIndexOf(".")+1);

            if(file_type === "jpg" || file_type === "jpeg" || file_type === "gif" || file_type === "png") {
                    this.setState({
                        value: event.target.value
                    });

                    /*****  Do not show this image on web page but upload it to S3;  *****/
                    /*****  it's a compressed version                                *****/
                    const files = [...event.target.files]
                    compress.compress(files, {
                          size: 2,      // the max size in MB, defaults to 2MB
                          quality: .8, // the quality of the image, max is 1,
                         // maxWidth: "100%", // the max width of the output image, defaults to 1920px
                         // maxHeight: "100%", // the max height of the output image, defaults to 1920px
                          resize: false, // defaults to true, set false if you do not want to resize the image width and height
                    }).then((data) => {
                          const img1 = data[0]
                          const base64str = img1.data
                          const imgExt = img1.ext
                          const file = Compress.convertBase64ToFile(base64str, imgExt)
                          this.file = file;
                    })
                    /*  END Image Compression  */

                    /***  Original file upload without image compression and it displays the image ***/
                    /***   the image shown is not uploaded since there is no "this.file = ..."     ***/
                    let reader = new FileReader();

                    reader.onload = (e) => {
                        var max_width  = "100%";
                        var max_height = "100%";
                        var target = e.target.result;

                        var img_src_tmp = getImgOrDocTag(target, file_type, max_width, max_height);

                        this.setState({
                            imageSrc: img_src_tmp,
                            imageTestSrc: target,
                            fileType: file_type
                        });
                    };
                    reader.readAsDataURL(event.target.files[0]);
            } else {
                var body_text  = "Sorry, you can only upload images (in .jpg or .png format).";
                this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            }
        }
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    onMainImgLoad = ({ target: img }) => {
        console.log("onMainImgLoad---------");
        console.log("img.width: " + img.width);
        console.log("img.height: " + img.height);

        this.setState({
          mainImgWidth: img.width,
          mainImgHeight: img.height,
        });
    };

    createScreenshot() {
        /*html2canvas(document.getElementById("screen"), {
            logging: true,
            profile: true,
            useCORS: true,
            width:  "100%",
            height: "100%"
        }).then(canvas => {
            var data = canvas.toDataURL('image/jpeg', 0.9);
            var src = encodeURI(data);
            document.getElementById('screenshot').src = src;
        });

        /*html2canvas(document.querySelector("#screen")).then(canvas => {
            document.getElementById('screenshot').appendChild(canvas)

        });*/
        setTimeout(() => {
            html2canvas(document.getElementById('screen'), {
                    logging: true,
                    profile: true,
                    useCORS: true,
                    width: 800,
                    height: 800 }).then(function(canvas) {
                var data = canvas.toDataURL('image/jpeg', 0.9);
                var src = encodeURI(data);
                document.getElementById('screenshot').src = src;
                //this.saveAs(canvas.toDataURL(), 'file-name.png');
            });
        }, 1000);
    }


    saveAs = (uri, filename) => {
        window.open(uri);
    }

    handleOptionChange = (event) => {
        var option = event.target.value;
        console.log("option: " + option);
        this.setState({
                selectedOption: option,
                exerciseSaved: true
        });

        setTimeout(
            function() {
                this.setState({exerciseSaved: false});
            }
            .bind(this), 2000
        );
    }


    renderForm() {
        var img_src; // = this.state.imageSrc;
        var img_test_src = this.state.imageTestSrc;
        var img_logo = "";
        var img_fade = "";
        var main_img_height  = 0;
        var footer_text_ypos = 0;
        var show_total_workout_time = '';
        if(img_test_src != undefined) {
            img_logo = "https://ts-white-label-website.s3-us-west-2.amazonaws.com/asp/logos/logo.png";
            img_src = <img id="target" src={img_test_src} onLoad={this.onMainImgLoad}  style={{maxHeight: "100%", maxWidth: "100%", objectFit:'cover'}}/>

            main_img_height = this.state.mainImgHeight - 51;// 182; //32
            img_fade = <span className="dashboardImageFadeSocialPhoto" style={{position: "absolute", top:main_img_height/*top: main_img_height*/}}></span>
            footer_text_ypos = main_img_height+15;
        }

        if(this.state.selectedOption === "total_workout_time")
            show_total_workout_time = <span>
                                            <FontAwesomeIcon icon={faStopwatch} className="socialPhotoFooterIcon"/>
                                            <div className="socialPhotoFooter">
                                                <div className="socialPhotoFooterText">Workout Time</div>
                                                <b className="socialPhotoFooterSubText">1 hr 5 mins</b>
                                            </div>
                                      </span>

        var photo_form =  <span style={{position:"relative", top:0}}>

                               { /*}<ControlLabel className="loginTFLabels">Title</ControlLabel>
                               <FormControl
                                   className="trackerTf" value={this.state.title}
                                   onChange={this.handleTitleChange} style={{fontSize:22}}
                               />*/ }
                               <span className="trackerVertSpacer" />

                               <span style={{width:"100%",  position:"relative", top:0, left:25, backgroundColor: "#ddd", padding:17,  border:"0px solid #000"}}>
                                       <label id="documentFile"> Upload Image
                                               <FormControl onChange = {this.handleFileChange}
                                                            style    = {{outline:"none", display: "none", fontSize:"16px", width:"100px" /*width = hide text: 'no file chosen' */}}
                                                            value    = {this.state.inputValue}
                                                            type     = "file" />
                                       </label>
                               </span>
                               <span style={{position:"relative", top:0, left:125 }}>
                                   <button onClick={this.createScreenshot}> Take Screenshot</button>
                               </span>

                               <div>
                                 <label className="settingsExercRadioBtns">
                                       <input type="radio"
                                              value="total_workout_time"
                                              checked={this.state.selectedOption === 'total_workout_time'}
                                              onChange={this.handleOptionChange} />
                                          <span className="radioBtnSettingsExerciseLabel-old">Workout Time</span>
                                 </label>
                               </div>
                               <label className="settingsExercRadioBtns">
                                   <input type="radio"
                                          value="total_workouts"
                                          checked={this.state.selectedOption === 'total_workouts'}
                                          onChange={this.handleOptionChange} />
                                      <div className="radioBtnSettingsExerciseLabel-old">Workouts in 30 Days</div>
                               </label>
                               <br/><br/>
                               { /******************************************************/ }
                               { /****************  Social Img Container  **************/ }
                               <div id="screen" className="socialPhotoImgContainer">
                                   <div className="formLabel pull-left socialPhotoImg">

                                       { /*****************  FOOTER: 1 REP MAX  ****************/ }
                                       <div style={{position: "relative", top: footer_text_ypos, width:"100%", textAlign: "center", zIndex:2000, border: "0px solid red"}}>
                                           {show_total_workout_time}
                                       </div>
                                       { /*****************  FOOTER: 1 REP MAX  **************** / }
                                       <div style={{position: "relative", top: footer_text_ypos - 102, width:"33%", textAlign: "center", zIndex:2000, border: "0px solid red"}}>
                                           <FontAwesomeIcon icon={faDumbbell} className="socialPhotoFooterIcon"/>
                                           <div className="socialPhotoFooter">
                                               <div className="socialPhotoFooterText">One Rep Max</div>
                                               <b className="socialPhotoFooterSubText">210 Lbs</b>
                                           </div>
                                       </div> */ }
                                       { img_fade }
                                       <span className="socialPhotoImgOnly">
                                           {img_src}
                                       </span>
                                   </div>
                                   <div className="socialPhotoLogo">
                                       <img id="target" src={img_logo} style={{position: "absolute", top: 20,maxWidth:300, maxHeight: 60}} />
                                   </div>
                               </div>
                               <div className="trackerVertSpacer" />
                               <br/><br/><br/><br/>
                               <div style={{position: "absolute", top: 1000, height: 600 }}><img src="" id="screenshot" width={this.state.mainImgHeight} height="100%"/></div>

                               { /*}<LoaderButton
                                   block
                                   //disabled={!this.validateForm()}
                                   type        = "submit"
                                   btncolor    = { Colors.ok_button_bg }
                                   fontSize    = {20}
                                   height      = {40}
                                   isLoading   = {this.state.isLoading}
                                   text        = "Submit"
                                   loadingText = "Submitting progress form data …"
                               />*/ }
                       </span>

        // if(this.state.form_submitted) show_form = <span style={{fontSize: 20}}>Thanks, your progress information was submitted.</span>
        return (
          <form onSubmit={this.handleSubmit}>
              <h2 style={{position: "relative", left: 25}}>Workout Photo</h2>

              <br/>
              { photo_form }
          </form>
        );
    }

    render() {
        let closeModalAlert        = () => this.setState({ showModalAlert: false }); //close simple modal window

        return (
          <div className="ProgressTracker-old">
              { /*}<img id="target" src={this.state.imageTestSrc} className="" style={{position:"absolute", float:"left", left: "-220px", top: 500, zIndex: 2000}} />*/ }
            {this.props.isAuthenticated ? this.renderForm() : <RenderLander />}
            {this.state.showModalAlert ?
                <ModalAlert
                    onHide         = {closeModalAlert}
                    alertFunction  = {this.alertFunction}     // custom function to call within modal
                    alertAction    = {this.state.alertAction} // flag used for above function
                    alertObject    = {this.state.alertObject} // vars used for above function
                    showModalAlert = {this.state.showModalAlert}
                    messageTitle   = {this.state.modalAlertTitleText}
                    messageBody    = {this.state.modalAlertBodyText}
                />
            : null}

          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/photo/SocialPhoto.js